export default __webpack_public_path__ + "/dist/images/3207754.730d912c54d013ae7c5e6532bb24ca45.png";